import { useSearchParams } from 'react-router-dom';

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQueryParams = (params) => setSearchParams(params);

  const queryParams = Array.from(searchParams.entries()).reduce((previousValue, [key, value]) => ({
    ...previousValue,
    [key]: value
  }), {});

  return [queryParams, setQueryParams];
};
export default useQueryParams;
